// http://www.cs.virginia.edu/~robins/quotes.html
import { fontList } from '../../core/font-list';
import { colorListPairs } from '../../core/color-list';

export let params = {
  'category': 'still',
  'parameters': {
    'size': {
      'default': {
        'key': '294 x 196',
        'value': [294, 196],
        'label': '294 x 196'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '1500 x 1000',
          'value': [1500, 1000],
          'label': '1500 x 1000'
        },
        {
          'key': '1200 x 800',
          'value': [1200, 800],
          'label': '1200 x 800'
        },
        {
          'key': '900 x 600',
          'value': [900, 600],
          'label': '900 x 600'
        },
        {
          'key': '600 x 400',
          'value': [600, 400],
          'label': '600 x 400'
        },
        {
          'key': '450 x 300',
          'value': [400, 300],
          'label': '400 x 300'
        },
        {
          'key': '294 x 196',
          'value': [294, 196],
          'label': '294 x 196'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting van de visualisatie, wordt genegeerd als schaalbaar aan staat',
    },
    'width': {
      'default': 600,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 400,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'colorScheme': {
      'default': colorListPairs[3],
      'control': 'cbs-color-scheme',
    },
    'circleColorScheme': {
      'default': colorListPairs[1],
      'control': 'cbs-color-scheme',
      'description': 'Kleur van de circel',
    },
    'offsetX': {
      'default': 420,
      'label': 'Afstand X',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand t.o.v. de linkerkant',
    },
    'offsetY': {
      'default': 180,
      'label': 'Afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand t.o.v. de bovenkant',
    },
    'circleSize': {
      'default': 200,
      'label': 'Radius circle',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Groote van de circle',
    },
    'marginLeft': {
      'default': 120,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 120,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 170,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Ruimte tussen de titelbalk en de bovenkant van de grafiek',
    },
    'marginBottom': {
      'default': 190,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'formatLocale': {
      'default': {
        'key': 'nl-nl',
        'value': 'nl-nl',
        'label': 'Nederlands'
      },
      'label': 'Taal',
      'type': 'string',
      'values' : [
        {
          'key': 'nl-nl',
          'value': 'nl-nl',
          'label': 'Nederlands'
        },
        {
          'key': 'en-gb',
          'value': 'en-gb',
          'label': 'Engels'
        }
      ],
      'control': 'standard-select',
      'description': 'Taal voor het formatteren van de Y-as labels',
    },
  },
  'data': {
    'values': [[0.86]],
    'columnLimitMin': 1,
    'columnLimitMax': 1,
    'columnLabelNumber': 0,
    'rowLimitMin': 1,
    'rowLimitMax': 5,
    'rowLabelNumber': 0,
  },
  'parameterGroups': [
    {
      'title': 'Primair',
      'collapsed': false,
      'keys': ['size','colorScheme','offsetX','offsetY'],
    },
    {
      'title': 'Secundair',
      'collapsed': true,
      'keys': ['circleSize','circleColorScheme'],
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/animations/test/still.params.ts